//@ts-nocheck
import { PageHeader } from 'components/header';
import PageTemplate from 'PageTemplates/PageTemplate';
import React, { useState, useRef } from 'react';
import { Button, Tab, Tabs } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { setStoragePageKey } from 'services/store/actions/view';
import StorageItemsTab from './components/StorageItemsTab';
import StorageOrdersTab from './components/StorageOrdersTab';
import StorageHistoryTab from './components/StorageHistoryTab';
import StorageItemModal from './components/StorageItemModal';
import StorageUpdateModal from './components/StorageUpdateModal';

const StoragePage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const user = useSelector((state) => state.auth.user);
  const key = useSelector((state) => state.view.storagePageKey);
  const [isProductModal, setIsProductModal] = useState(false);
  const [editingItem, setEditingItem] = useState(null);
  const [isUpdateModal, setIsUpdateModal] = useState(false);
  const [updatingItem, setUpdatingItem] = useState(null);
  const storageItemsTabRef = useRef(null);

  const handleTab = (k) => {
    dispatch(setStoragePageKey(k));
  };

  const handleAddProduct = () => {
    setEditingItem(null);
    setIsProductModal(true);
  };

  const handleEditProduct = (item) => {
    setEditingItem(item);
    setIsProductModal(true);
  };

  const handleUpdateQuantity = (item) => {
    setUpdatingItem(item);
    setIsUpdateModal(true);
  };

  const handleNewOrder = () => {
    history.push('/storage/new-order');
  };

  const handleModalSuccess = () => {
    // Odświeżenie listy produktów po dodaniu/edycji
    if (
      storageItemsTabRef.current &&
      storageItemsTabRef.current.refreshItems
    ) {
      storageItemsTabRef.current.refreshItems();
    }
  };

  const handleCloseModal = () => {
    setIsProductModal(false);
    setEditingItem(null);
  };

  const handleCloseUpdateModal = () => {
    setIsUpdateModal(false);
    setUpdatingItem(null);
  };
  return (
    <PageTemplate>
      <PageHeader
        title="Magazyn"
        extra={[
          <Button
            key="add-item"
            variant="outline-success"
            onClick={handleAddProduct}
          >
            Dodaj produkt
          </Button>,
          <Button key="new-order" onClick={handleNewOrder}>
            Nowe zamówienie
          </Button>,
        ]}
      />
      <Tabs activeKey={key} onSelect={handleTab}>
        <Tab eventKey="items" title="Elementy">
          {key === 'items' && (
            <StorageItemsTab
              ref={storageItemsTabRef}
              onEdit={handleEditProduct}
              onUpdateQuantity={handleUpdateQuantity}
            />
          )}
        </Tab>
        <Tab eventKey="orders" title="Zamówienia">
          {key === 'orders' && <StorageOrdersTab />}
        </Tab>
        <Tab eventKey="history" title="Historia">
          {key === 'history' && <StorageHistoryTab />}
        </Tab>
      </Tabs>

      {/* MODALS */}
      {isProductModal && (
        <StorageItemModal
          closeModal={handleCloseModal}
          onSuccess={handleModalSuccess}
          item={editingItem}
        />
      )}

      {isUpdateModal && (
        <StorageUpdateModal
          show={isUpdateModal}
          onHide={handleCloseUpdateModal}
          item={updatingItem}
          onSuccess={handleModalSuccess}
        />
      )}
    </PageTemplate>
  );
};

export default StoragePage;
